import { capitalize as capitalize$1 } from '@vue/shared';
export { camelize, hyphenate, hyphenate as kebabCase } from '@vue/shared';
const escapeStringRegexp = function () {
  let string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
const capitalize = str => capitalize$1(str);
export { capitalize, escapeStringRegexp };